import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { VacancyForm } from "@/model/vacancy";
import { fetchUpdateVacancy } from "@/store/slices/vacancy";

export const useCreateVacancyForm = (id: number) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return useFormik<VacancyForm>({
    initialValues: {
      name: "",
      customer_id: 0,
      project_id: 0,
      legal_entity_id: 0,
      profile_id: 0,
      candidate_requirements: "",
      candidate_grade: [],
      job_duties: "",
      job_format: "",
      job_workload: "",
      attraction_period: "",
      location: "",
      comments: "",
      salary_tk_max: 0,
      salary_ip_max: 0,
      salary_gph_max: 0,
      office_address: "",
      project_description: "",
      sales_max_offer_moscow: "",
      sales_max_offer_general: "",
      sales_max_offer_regions: "",
      marginality: 0,
      purchase_rate_max: "",
      required_number: 0,
      recruiters_ids: [],
      status: 0,
      attachments: [],
      attachments_delete: [],
    },
    validate: (values) => {
      const errors: Partial<Record<keyof VacancyForm, string>> = {};
      if (!values.name) errors.name = "Обязательное поле";
      if (!values.customer_id) errors.customer_id = "Обязательное поле";
      if (!values.project_id) errors.project_id = "Обязательное поле";
      if (!values.candidate_requirements) errors.candidate_requirements = "Обязательное поле";
      if (!values.job_duties) errors.job_duties = "Обязательное поле";
      if (!values.candidate_grade?.length) errors.candidate_grade = "Обязательное поле";
      if (!values.required_number) errors.required_number = "Обязательное поле";
      if (!values.job_format) errors.job_format = "Обязательное поле";
      if (!values.job_workload) errors.job_workload = "Обязательное поле";
      if (!values.recruiters_ids?.length) errors.recruiters_ids = "Обязательное поле";
      return errors;
    },
    onSubmit: (values) => {
      dispatch(fetchUpdateVacancy({ params: { id }, body: values })).then((res) => {
        if (res.payload && "id" in res.payload) {
          navigate(`/vacancy/${res.payload.id}`);
        }
      });
    },
  });
};

export const useUpdateVacancyForm = (id: number) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return useFormik<VacancyForm>({
    initialValues: {
      name: "",
      customer_id: 0,
      project_id: 0,
      legal_entity_id: 0,
      profile_id: 0,
      candidate_requirements: "",
      candidate_grade: [],
      job_duties: "",
      job_format: "",
      job_workload: "",
      attraction_period: "",
      location: "",
      comments: "",
      salary_tk_max: 0,
      salary_ip_max: 0,
      salary_gph_max: 0,
      office_address: "",
      project_description: "",
      sales_max_offer_moscow: "",
      sales_max_offer_general: "",
      sales_max_offer_regions: "",
      marginality: 0,
      purchase_rate_max: "",
      required_number: 0,
      recruiters_ids: [],
      status: 0,
      attachments: [],
      attachments_delete: [],
    },
    validate: (values) => {
      const errors: Partial<Record<keyof VacancyForm, string>> = {};
      if (!values.name) errors.name = "Обязательное поле";
      if (!values.customer_id) errors.customer_id = "Обязательное поле";
      if (!values.project_id) errors.project_id = "Обязательное поле";
      if (!values.candidate_requirements) errors.candidate_requirements = "Обязательное поле";
      if (!values.job_duties) errors.job_duties = "Обязательное поле";
      if (!values.candidate_grade?.length) errors.candidate_grade = "Обязательное поле";
      if (!values.required_number) errors.required_number = "Обязательное поле";
      if (!values.job_format) errors.job_format = "Обязательное поле";
      if (!values.job_workload) errors.job_workload = "Обязательное поле";
      if (!values.recruiters_ids?.length) errors.recruiters_ids = "Обязательное поле";
      if (!values.legal_entity_id) errors.legal_entity_id = "Обязательное поле";
      if (!values.profile_id) errors.profile_id = "Обязательное поле";
      if (!values.legal_entity_id) errors.legal_entity_id = "Обязательное поле";
      return errors;
    },
    onSubmit: (values) => {
      dispatch(fetchUpdateVacancy({ params: { id }, body: values })).then((res) => {
        if (res.payload && "id" in res.payload) { 
          navigate(`/vacancy/${id}`);
        }
      });
    },
  });
};
